<template>
  <div v-on:keyup.enter="onEnter">
    <b-sidebar :id="sidebarId" ref="refSidebar" :title="title" right shadow backdrop-variant="white" variant="white" backdrop>
      <template #footer>
        <div style="gap: .5rem; justify-content: space-between"
          class="d-flex bg-dark text-light align-items-center px-3 py-2">
          <button
            type="button"
            class="btn rounded-4 btn-third"
            @click="$emit('submit')"
            :disabled="isLoading"
          >
            <i class="fas" :class="isLoading ? 'fa-spinner fa-spin' : 'fa-search'"></i>
            {{ isLoading ? 'Carregando...' : 'Filtrar' }}
          </button>
          <button
            type="button"
            class="btn rounded-4 btn-default w-100"
            @click="$emit('clear')"
            :disabled="isLoading"
          >
            <i class="fas fa-trash-alt"></i>
            Limpar Filtros
          </button>
        </div>
      </template>
      <div class="search__body__container">
        <slot>
        </slot>
      </div>
    </b-sidebar>
  </div>
</template>
<script>

export default {
  name: 'NxSearch',
  props: {
    title: {
      type: String,
      required: false,
      default: 'Pesquisar'
    },
    sidebarId: {
      type: String,
      required: false,
      default: 'sidebar-1'
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      checkInterval: null
    }
  },
  mounted () {
    // Função para forçar z-index
    const sidebarId = this.sidebarId
    const forceZIndex = () => {
      const sidebarEl = document.getElementById(sidebarId)
      if (sidebarEl && sidebarEl.classList.contains('show')) {
        // Tenta encontrar o backdrop de várias formas
        let backdropEl = document.querySelector(`#${sidebarId} ~ .b-sidebar-backdrop`) ||
                        document.querySelector(`.b-sidebar-backdrop[data-sidebar-id="${sidebarId}"]`) ||
                        document.querySelector('.b-sidebar-backdrop:last-of-type') ||
                        document.querySelector('.b-sidebar-backdrop')

        sidebarEl.style.setProperty('z-index', '999999', 'important')
        sidebarEl.style.setProperty('position', 'fixed', 'important')

        if (backdropEl) {
          backdropEl.style.setProperty('z-index', '999998', 'important')
          backdropEl.style.setProperty('position', 'fixed', 'important')
          backdropEl.style.setProperty('top', '0', 'important')
          backdropEl.style.setProperty('left', '0', 'important')
          backdropEl.style.setProperty('width', '100vw', 'important')
          backdropEl.style.setProperty('height', '100vh', 'important')
        }

        // Força também todos os backdrops visíveis a terem z-index menor
        const allBackdrops = document.querySelectorAll('.b-sidebar-backdrop')
        allBackdrops.forEach(backdrop => {
          if (backdrop !== backdropEl) {
            backdrop.style.setProperty('z-index', '999997', 'important')
          }
        })
      }
    }

    // Escuta eventos do Bootstrap Vue
    this.$root.$on('bv::sidebar::show', (id) => {
      if (id === sidebarId) {
        this.$nextTick(() => {
          forceZIndex()
          // Verifica continuamente enquanto sidebar estiver aberta
          if (this.checkInterval) {
            clearInterval(this.checkInterval)
          }
          this.checkInterval = setInterval(() => {
            const sidebarEl = document.getElementById(sidebarId)
            if (sidebarEl && sidebarEl.classList.contains('show')) {
              forceZIndex()
            } else {
              clearInterval(this.checkInterval)
              this.checkInterval = null
            }
          }, 50)
        })
      }
    })

    this.$root.$on('bv::sidebar::hide', (id) => {
      if (id === sidebarId && this.checkInterval) {
        clearInterval(this.checkInterval)
        this.checkInterval = null
      }
    })

    // Também escuta o evento de toggle usado pela tela de Advogado
    this.$root.$on('bv::toggle::collapse', (id) => {
      if (id === sidebarId) {
        this.$nextTick(() => {
          forceZIndex()
          if (this.checkInterval) {
            clearInterval(this.checkInterval)
          }
          this.checkInterval = setInterval(() => {
            const sidebarEl = document.getElementById(sidebarId)
            if (sidebarEl && sidebarEl.classList.contains('show')) {
              forceZIndex()
            } else {
              clearInterval(this.checkInterval)
              this.checkInterval = null
            }
          }, 50)
        })
      }
    })
  },
  beforeDestroy () {
    this.$root.$off('bv::sidebar::show')
    this.$root.$off('bv::sidebar::hide')
    this.$root.$off('bv::toggle::collapse')
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
  },
  methods: {
    onEnter () {
      this.$emit('submit')
      this.$refs.refSidebar.hide()
    },
    show () {
      // Método para abrir a sidebar externamente
      if (this.$refs.refSidebar) {
        this.$refs.refSidebar.show()
        // Força z-index após abrir
        this.$nextTick(() => {
          const sidebarEl = document.getElementById(this.sidebarId)
          // Tenta encontrar o backdrop de várias formas
          let backdropEl = document.querySelector(`#${this.sidebarId} ~ .b-sidebar-backdrop`) ||
                          document.querySelector(`.b-sidebar-backdrop[data-sidebar-id="${this.sidebarId}"]`) ||
                          document.querySelector('.b-sidebar-backdrop:last-of-type') ||
                          document.querySelector('.b-sidebar-backdrop')

          if (sidebarEl) {
            sidebarEl.style.setProperty('z-index', '999999', 'important')
            sidebarEl.style.setProperty('position', 'fixed', 'important')
          }
          if (backdropEl) {
            backdropEl.style.setProperty('z-index', '999998', 'important')
            backdropEl.style.setProperty('position', 'fixed', 'important')
            backdropEl.style.setProperty('top', '0', 'important')
            backdropEl.style.setProperty('left', '0', 'important')
            backdropEl.style.setProperty('width', '100vw', 'important')
            backdropEl.style.setProperty('height', '100vh', 'important')
          }

          // Força também todos os backdrops visíveis a terem z-index menor
          const allBackdrops = document.querySelectorAll('.b-sidebar-backdrop')
          allBackdrops.forEach(backdrop => {
            if (backdrop !== backdropEl) {
              backdrop.style.setProperty('z-index', '999997', 'important')
            }
          })
        })
      }
    },
    hide () {
      // Método para fechar a sidebar externamente
      if (this.$refs.refSidebar) {
        this.$refs.refSidebar.hide()
      }
    }
  }
}
</script>
<style lang="scss">
// Força a sidebar a ficar acima de tudo, mesmo com contextos de empilhamento
.b-sidebar[id^="sidebar-"] {
  top: 3.5rem !important;
  height: calc(100vh - 3.5rem) !important;
  z-index: 999999 !important;
  position: fixed !important;
}

.b-sidebar[id^="sidebar-"][style] {
  z-index: 999999 !important;
  position: fixed !important;
}

// Regras específicas para sidebar-1 (pesquisa de quadro)
.b-sidebar#sidebar-1 {
  top: 3.5rem !important;
  height: calc(100vh - 3.5rem) !important;
  z-index: 999999 !important;
  position: fixed !important;
}

.b-sidebar#sidebar-1[style] {
  z-index: 999999 !important;
  position: fixed !important;
}

// Regras específicas para sidebar-tag-search (pesquisa de tag)
.b-sidebar#sidebar-tag-search {
  top: 3.5rem !important;
  height: calc(100vh - 3.5rem) !important;
  z-index: 999999 !important;
  position: fixed !important;
}

.b-sidebar#sidebar-tag-search[style] {
  z-index: 999999 !important;
  position: fixed !important;
}

// Backdrop genérico
.b-sidebar-backdrop {
  z-index: 999998 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
}

.b-sidebar-backdrop[style] {
  z-index: 999998 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
}

// Garante que elementos dentro da sidebar também tenham z-index alto
.b-sidebar[id^="sidebar-"] * {
  position: relative;
  z-index: inherit;
}

.search__body {
  &__container {
    padding: 0 2rem 1rem 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/sidebars/SidebarSearch.vue